// JS for your graphic
import pym from "pym.js";
import {
  rollup,
  min,
  max,
  select,
  csv,
  scaleOrdinal,
  scalePoint,
  scaleSqrt,
} from "d3";
import data from "../data/schools.csv";

const draw = (data) => {
  // step 1: access data
  data.forEach((val) => {
    val.ap = +val["# of APs"] > 0;
    val.ib = val["IB Offered?"] == "Yes";
  });
  const grouped = rollup(
    data.filter(d => !d.School.toLowerCase().includes("home")),
    (v) => ({
      ap: v[0].ap,
      ib: v[0].ib,
      num: v.length,
    }),
    (d) => `${d.ap}${d.ib}`
  );
  console.log(grouped);
  // step 2: create chart dimensions
  const width = min([400, window.innerWidth]);
  const height = width;
  const margin = { top: 0, right: 0, bottom: 0, left: 0 };
  // step 3: draw canvas
  const svg = select("figure")
    .append("svg")
    .attr("width", width)
    .attr("height", height);
  const g = svg
    .append("g")
    .attr("transform", `translate(${margin.left}, ${margin.top})`);
  // step 4: create scales
  const xScale = scalePoint()
    .domain([true, false])
    .padding(0.5)
    .range([0, width - margin.left - margin.right]);
  const yScale = scalePoint()
    .padding(0.5)
    .domain([true, false])
    .range([height - margin.top - margin.bottom, 0]);
  const widthScale = scaleSqrt()
    .domain([0, max(Array.from(grouped.values()).map((d) => d.num))])
    .range([0, width / 2.0]);
  const colors = scaleOrdinal().range([
    "#F95D6A",
    "#FFA600",
    "#FF7C43",
    "#FFD600",
  ]);
  // step 5: draw data
  g.selectAll("rect.box")
    .data(Array.from(grouped.values()))
    .join("rect")
    .attr("opacity", 0.8)
    .attr("class", "box")
    .attr("x", (d) => xScale(d.ap) - widthScale(d.num) / 2)
    .attr("y", (d) => yScale(d.ib) - widthScale(d.num) / 2)
    .attr("width", (d) => widthScale(d.num))
    .attr("height", (d) => widthScale(d.num))
    .attr("fill", (_, i) => colors(i));

  const wrap = (text, width) => {
    text.each(function () {
      var text = select(this),
        words = text.text().split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.1, // ems
        x = text.attr("x"),
        y = text.attr("y"),
        dy = 0, //parseFloat(text.attr("dy")),
        tspan = text
          .text(null)
          .append("tspan")
          .attr("x", x)
          .attr("y", y)
          .attr("dy", dy + "em");
      while ((word = words.pop())) {
        line.push(word);
        tspan.text(line.join(" "));
        if (tspan.node().getComputedTextLength() > width(text.datum())) {
          line.pop();
          tspan.text(line.join(" "));
          line = [word];
          tspan = text
            .append("tspan")
            .attr("x", x)
            .attr("y", y)
            .attr("dy", ++lineNumber * lineHeight + dy + "em")
            .text(word);
        }
      }
    });
  };
  g.selectAll("text.label")
    .data(Array.from(grouped.values()))
    .join("text")
    .attr("class", "label")
    .attr("x", (d) => xScale(d.ap))
    .attr("y", (d) => yScale(d.ib))
    .text(
      (d) =>
        `${d.num} schools ${d.ap ? "" : "don't "}offer AP classes and ${
          d.ib ? "" : "don't "
        }offer the IB program`
    )
    .call(wrap, (d) => max([widthScale(d.num) - 10, 150]));
  // step 6: draw peripherals
  // step 7: set up interactions
};

const resize = () => {};

window.onload = function () {
  const pymChild = new pym.Child({ renderCallback: resize, polling: 500 });
  pymChild.sendHeight();

  csv(data).then(draw);
};
